// extracted by mini-css-extract-plugin
export default {"mr13":"_27560ce58ad0a7da9ac5b04d1e50cbe4"};